const dropdownData = [
  {
    title: 'HOME',
    items: [
      { label: 'Flash Sale', link: '/landingpage#flash-sale' },
      { label: 'Categories', link: '/landingpage#categories' },
      { label: 'Top Rated Choices', link: '/landingpage#top-rated' },
      { label: 'Promotions', link: '/landingpage#promotions' },
      { label: 'Trending Sales', link: '/landingpage#trending-sales' },
      { label: 'Save upto 10-50%', link: '/landingpage#discounts' },
      { label: 'New Arrivals', link: '/landingpage#new-arrivals' },
      { label: 'More Sales', link: '/landingpage#more-sales' },
      { label: 'Popular this Week', link: '/landingpage#popular-week' },
      { label: 'Popular this Month', link: '/landingpage#popular-month' },
      { label: 'Popular this Season', link: '/landingpage#popular-season' },
      { label: 'Highlighted Brands', link: '/landingpage#highlighted-brands' },
      { label: 'Recommended', link: '/landingpage#recommended' },
    ],
  },
  {
    title: 'FEATURES',
    items: [
      { label: 'Live Videos', link: '#' },
      { label: 'Mae Style', link: '#' },
      { label: 'Blogs', link: '#' },
      { label: 'Subscriptions', link: '/subscription-plans' },
      { label: 'Social Media Links', link: '/social-media-links' },
      { label: 'Testimonials', link: '/testimonials' },
      { label: 'Partnerships', link: '#' },
    ],
  },
  {
    title: 'OFFERS',
    items: [
      { label: 'Flash Sales', link: '#' },
      { label: 'Daily Deals', link: '#' },
      { label: 'Discounts & Coupons', link: '#' },
      { label: 'Seasonal Promotions', link: '#' },
      { label: 'Events Sale', link: '#' },
      { label: 'Limited Stock', link: '#' },
      { label: 'New Arrivals', link: '#' },
      { label: 'Gift Cards', link: '#' },
      { label: 'Group Buy', link: '#' },
      { label: 'Special Gifts', link: '#' },
    ],
  },
  {
    title: 'PAGES',
    items: [
      { label: 'Privacy Policy', link: '#' },
      { label: 'Contact Us', link: '/contact-us' },
      { label: 'FAQ’s', link: '/customer-services' },
      { label: 'Wishlist', link: '#' },
      { label: 'Purchase Protection', link: '#' },
      { label: 'Browser history', link: '#' },
    ],
  },
  {
    title: 'HELP',
    items: [
      { label: 'Customer Services', link: '/customer-services-section' },
      { label: 'Chat with Al Assistant', link: '#' },
    ],
  },
  {
    title: 'JOIN US',
    items: [
      { label: 'Seller Program', link: '/startselling' },
      { label: 'Affiliate Program', link: '#' },
      { label: 'Wholesale Program', link: '#' },
      { label: 'Retailer Program', link: '#' },
      { label: 'External Advertisement', link: '#' },
    ],
  },
  {
    title: 'ABOUT US',
    link: '/about-us'
  },
];

export default dropdownData;